module.exports = __webpack_public_path__ + "images/suso-logo-with-accents.png";